














































































































































































































































































import Vue from 'vue'

export default Vue.extend({
  name: 'pilot-print',
  props: {
    pilot: {
      type: Object,
      required: true,
    },
  },
})
